import { render, staticRenderFns } from "./FluxFondosStep1.vue?vue&type=template&id=378b2d56"
import script from "./FluxFondosStep1.vue?vue&type=script&lang=js"
export * from "./FluxFondosStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports